import { registerPlugin } from '@capacitor/core';
const CallNotification = registerPlugin('CallNotification', {
    web: () => import('./web').then((m) => new m.CallNotificationWeb()),
});
export * from './definitions';
export { CallNotification };
//# sourceMappingURL=index.js.map